import { Bell } from "lucide-react"
import { NOTIFICATION_TYPES, NotificationType } from "../constants"
import type { NotificationRenderer } from "../types"
import { creditsLow } from "./renderers/creditsLow"
import { declarationProcessingFailed } from "./renderers/declarationProcessingFailed"
import { declarationReadyForReview } from "./renderers/declarationReadyForReview"
import { documentIngestionFailed } from "./renderers/documentIngestionFailed"
import { questionnaireFailed } from "./renderers/questionnaireFailed"
import { questionnaireReady } from "./renderers/questionnaireReady"
import { taggedMissingAnswer } from "./renderers/taggedMissingAnswer"

/**
 * Producers can ship a new type before the dashboard deploys: unknown types
 * render this generic row, never crash, and clicking only acknowledges.
 */
export const FALLBACK: NotificationRenderer = {
  icon: Bell,
  accent: "default",
  title: () => ({ key: "NOTIF/FALLBACK/TITLE" }),
  // Unknown action: ack, never navigate.
  onAction: (_action, ctx) => ctx.markRead(),
}

/**
 * CI guard for the contract: `satisfies` makes the build fail if a type is
 * added to constants.ts without a renderer — you can't half-ship a
 * notification on the dashboard either.
 */
const RENDERERS = {
  [NOTIFICATION_TYPES.QUESTIONNAIRE_READY]: questionnaireReady,
  [NOTIFICATION_TYPES.QUESTIONNAIRE_FAILED]: questionnaireFailed,
  [NOTIFICATION_TYPES.DOCUMENT_INGESTION_FAILED]: documentIngestionFailed,
  [NOTIFICATION_TYPES.DECLARATION_READY_FOR_REVIEW]: declarationReadyForReview,
  [NOTIFICATION_TYPES.DECLARATION_PROCESSING_FAILED]: declarationProcessingFailed,
  [NOTIFICATION_TYPES.CREDITS_LOW]: creditsLow,
  [NOTIFICATION_TYPES.TAGGED_MISSING_ANSWER]: taggedMissingAnswer,
} satisfies Record<NotificationType, NotificationRenderer>

export const resolve = (type: string): NotificationRenderer =>
  (RENDERERS as Record<string, NotificationRenderer>)[type] ?? FALLBACK
